"use strict";

angular
  .module(ApplicationConfiguration.applicationModuleName)
  .config(function ($stateProvider, $urlRouterProvider) {
    $urlRouterProvider.otherwise("/login");

    $stateProvider.state("main", {
      url: "/",
      views: {
        "": {
          templateUrl: "/modules/Commom/core/views/layout.html",
          controller: "controlPanelCtrl",
          controllerAs: "vm",
        },
      },
    });

    // Login
    $stateProvider.state("login", {
      url: "/login",
      views: {
        "": {
          templateUrl: "/modules/Commom/auth/views/main.html",
        },
        "auth@login": {
          templateUrl: "/modules/Commom/auth/views/login.html",
          controller: "authCtrl",
          controllerAs: "vm",
        },
      },
    });

    // Sign Up
    $stateProvider.state("signup", {
      url: "/signup?token",
      views: {
        "": {
          templateUrl: "/modules/Commom/auth/views/main.html",
        },
        "auth@signup": {
          templateUrl: "/modules/Commom/auth/views/signup.html",
          controller: "signupCtrl",
          controllerAs: "vm",
        },
      },
    });

    // Forgot Password
    $stateProvider.state("forgotPassword", {
      url: "/password",
      views: {
        "": {
          templateUrl: "/modules/Commom/auth/views/main.html",
        },
        "auth@forgotPassword": {
          templateUrl: "/modules/Commom/auth/views/password.forgot.html",
          controller: "forgotPasswordCtrl",
          controllerAs: "vm",
        },
      },
    });

    // Password Reset
    $stateProvider.state("passwordReset", {
      url: "/passwordreset?email&token",
      views: {
        "": {
          templateUrl: "/modules/Commom/auth/views/main.html",
        },
        "auth@passwordReset": {
          templateUrl: "/modules/Commom/auth/views/password.reset.html",
          controller: "passwordResetCtrl",
          controllerAs: "vm",
        },
      },
    });
  });
